import { aboutContent } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="max-w-[720px] mx-auto text-center">
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-4">
              {aboutContent.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              {aboutContent.description}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}